import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@pages/index/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/pages/index/index',
    name: 'Index',
    component: Home
  },
  {
    path: '/pages/news/category',
    name: 'Category',
    component: () => import('@pages/news/category.vue')
  },
  {
    path: '/pages/news/article',
    name: 'Article',
    component: () => import('@pages/news/article.vue')
  },
  {
    path: '/pages/bingo/index',
    name: 'Bingo',
    component: () => import('@pages/bingo/index.vue')
  },
  {
    path: '/pages/sports/livescore',
    name: 'LiveScore',
    component: () => import('@pages/sports/livescore.vue')
  },
  {
    path: '/pages/sports/index',
    name: 'Sports',
    component: () => import('@pages/sports/index.vue')
  },
  {
    path: '/pages/liveStream/index',
    name: 'LiveStream',
    component: () => import('@pages/liveStream/index.vue')
  },
  {
    path: '/pages/sports/videoInPlay',
    name: 'VideoInPlay',
    component: () => import('@pages/sports/videoInPlay.vue')
  },
  {
    path: '/pages/open/index',
    name: 'Open',
    component: () => import('@pages/open/index.vue')
  },
  {
    path: '/pages/open/livescore',
    name: 'OpenLiveScore',
    component: () => import('@pages/open/livescore.vue')
  },
  {
    path: '/pages/sports/basketball',
    name: 'Basketball',
    component: () => import('@pages/sports/basketball.vue')
  },
  {
    path: '/pages/contact/index',
    name: 'Contact',
    component: () => import('@pages/contact/index.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',  // 改用 hash 模式，不需要服务器配置
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（浏览器前进/后退），使用保存的位置
    if (savedPosition) {
      return savedPosition
    } else {
      // 否则滚动到顶部
      return { x: 0, y: 0 }
    }
  }
})

// 修复重复导航错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err)
    }
  })
}

export default router

